'use client';

import type { ReactElement } from 'react';

type ExperimentLoaderProps = {
  children: ReactElement;
};

const ExperimentLoader = ({ children }: ExperimentLoaderProps) => children;

export default ExperimentLoader;
